import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popover, Select, message } from "antd";
import { FaTrash } from "react-icons/fa";
import { AiOutlineReload } from "react-icons/ai";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { getAllUsers } from "../../redux/actions/user";
import { useQuery, gql, useMutation, useLazyQuery } from "@apollo/client";

import { RiSearchLine } from "react-icons/ri";
import { ALL_USERS } from "../../GraphQl/Queries";
import "./AllUsers.css";
import AntdTable from "../../components/Table/Table";
import { roles } from "../../constants/Roles";
import {
  DELETE_USER_MUTATION,
  UPDATE_USER_MUTATION,
} from "../../GraphQl/Mutations";
import Loader from "../../components/Loader";
import { maskPhoneNumber } from "../../functions";

const AllUsers = () => {
  const [userType, setUserType] = useState(roles.ADMIN);
  const [getAllUsersList, { error, loading, data }] = useLazyQuery(ALL_USERS, {
    fetchPolicy: "cache-and-network",
    variables: {
      userType: userType,
    },

    onCompleted: (data) => {
      success("Fetched data successfully");
      setUsers(data.getAllUsers);
      setLocalUsers(data.getAllUsers);
    },
    onError: (error) => {
      err(error.message);
    },
  });
  const [updateUserObj, setUpdateUserObj] = useState({ id: null, type: null });
  const [updateUser, update] = useMutation(UPDATE_USER_MUTATION, {
    variables: {
      updateUserDataInput: {
        userType: updateUserObj?.type,
      },
      updateUserId: updateUserObj?.id,
    },
    onCompleted: () => {
      getAllUsersList();
      success("Deleted User Successfully!");
      setTrial(false);
    },
    onError: (error) => {
      err(error.message);
      setTrial(false);
    },
  });

  const [deleteUser, del] = useMutation(DELETE_USER_MUTATION, {
    variables: {
      deleteUserId: updateUserObj.id,
    },
    onCompleted: () => {
      getAllUsersList();
      success("Deleted User Successfully!");
    },
    onError: (err) => {
      err(err.message);
    },
  });
  const [users, setUsers] = useState([]);
  const [localUsers, setLocalUsers] = useState([]);
  const [trial, setTrial] = useState([]);
  const [PageSize, setPageSize] = useState(8);
  const state = useSelector((state) => state.users);
  const dispatch = useDispatch();
  const [paginateStatus, setPaginateStatus] = useState({
    current: 1,
    pageSize: PageSize,
  });
  const [messageApi, contextHolder] = message.useMessage();
  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const err = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  const customStyles = {
    menuPortal: (provided) => ({ ...provided, zIndex: " 99999 !important" }),
  };

  const options = [
    { value: roles.SURVEYOR, label: roles.SURVEYOR },
    { value: roles.ADMIN, label: roles.ADMIN },
    { value: roles.SUPER_ADMIN, label: roles.SUPER_ADMIN },
  ];

  const columns = [
    {
      title: "Name",
      // dataIndex: "fullName",
      // key: "fullName",
      render: (text, record) => (
        <div className='flex flex-col items-start content-start'>
          <span className='surveyorName'>{record?.fullName}</span>
          <span className='surveyorEmail'>{record?.email}</span>
        </div>
      ),
    },
    {
      title: "Address",
      // dataIndex: "fullName",
      // key: "fullName",
      render: (text, record) => (
        <div className='flex flex-col items-start content-start'>
          {Object?.keys(record?.address)
            // .splice(1)
            ?.map((key) => (
              <>{key !== "__typename" && record?.address[key]} &nbsp;</>
            ))}
        </div>
      ),
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      key: "phone",
      render: (text) => <span>{maskPhoneNumber(text)}</span>,
    },
    {
      title: "Date of Birth",
      dataIndex: "date_of_birth",
      key: "date_of_birth",
    },
    {
      title: "Organization",

      render: (text, record) => (
        <>
          {record?.userDetails?.organization?.organizationName || "Unavailable"}
        </>
      ),
    },
    {
      title: "Created At",
      width: "15.66%",

      render: (text, record) => (
        <>
          {/* {format(record?.createdAt, "MM/dd/yyyy")} */}
          {record?.createdAt?.split("T")[0]}
          {/* <Select
            options={options}
            defaultValue={options.filter(
              (type) => type.value === record?.userType
            )}
            onChange={(e) => {
              setUpdateUserObj({ id: record?._id, type: e });
              setTimeout(() => updateUser(), 0);
            }}
            styles={customStyles}
          /> */}
          {/* <span className="tableActionButton">
            <FaTrash />
          </span> */}
        </>
      ),
    },
    {
      title: "Role",
      width: "10.66%",

      render: (text, record) => (
        <>
          {record?.userType}
          {/* <Select
            options={options}
            defaultValue={options.filter(
              (type) => type.value === record?.userType
            )}
            onChange={(e) => {
              setUpdateUserObj({ id: record?._id, type: e });
              setTimeout(() => updateUser(), 0);
            }}
            styles={customStyles}
          /> */}
          {/* <span className="tableActionButton">
            <FaTrash />
          </span> */}
        </>
      ),
    },
    {
      title: "Actions",
      width: "5%",

      render: (text, record) => (
        <>
          <Popover
            placement='leftBottom'
            content={
              <div className='tablepopup'>
                {(record?.userType == "ADMIN" ||
                  record?.userType == "SURVEYOR") && (
                  <button
                    className='btn'
                    onClick={(e) => {
                      setUpdateUserObj({
                        id: record?._id,
                        type: roles.SUPER_ADMIN,
                      });
                      setTimeout(() => updateUser(), 0);
                    }}
                  >
                    {update?.loading && <Loader />}
                    Promote to Super Admin
                  </button>
                )}

                {(record?.userType == "ADMIN" ||
                  record?.userType == "SUPER_ADMIN") && (
                  <button
                    className='btn'
                    onClick={(e) => {
                      setUpdateUserObj({
                        id: record?._id,
                        type: roles.SURVEYOR,
                      });
                      setTimeout(() => updateUser(), 0);
                    }}
                  >
                    {update?.loading && <Loader />}
                    Demote to Surveyor{" "}
                  </button>
                )}

                {record?.userType == "SURVEYOR" && (
                  <button
                    className='btn'
                    onClick={() => {
                      setUpdateUserObj({
                        id: record?._id,
                        type: roles.ADMIN,
                      });
                      setTimeout(() => updateUser(), 0);
                    }}
                  >
                    {update?.loading && <Loader />}
                    Promote to Admin{" "}
                  </button>
                )}

                <button
                  className='btn btn-warning'
                  onClick={() => {
                    setUpdateUserObj({
                      id: record?._id,
                    });
                    setTimeout(() => deleteUser(), 0);
                  }}
                >
                  <span className='tableActionButton'>
                    {del.loading ? (
                      <Loader color='#111' />
                    ) : (
                      <FaTrash size={15} />
                    )}
                  </span>
                  Delete User
                </button>
              </div>
            }
            trigger='click'
          >
            <HiOutlineDotsVertical />
          </Popover>

          {/* <Select
            options={options}
            defaultValue={options.filter(
              (type) => type.value === record?.userType
            )}
            onChange={(e) => {
              setUpdateUserObj({ id: record?._id, type: e });
              setTimeout(() => updateUser(), 0);
            }}
            styles={customStyles}
          /> */}
          {/* <span className="tableActionButton">
            <FaTrash />
          </span> */}
        </>
      ),
    },
  ];

  useEffect(() => {
    getAllUsersList();
  }, []);
  useEffect(() => {
    getAllUsersList();
  }, [userType]);

  const handleChange = (e) => {
    let value = e.target.value.toLowerCase();
    let temp = data?.getAllUsers;
    let searchArray = users?.filter(
      (item) =>
        item?.fullName?.toLowerCase()?.includes(value) ||
        item?.email?.toLowerCase()?.includes(value) ||
        item?.organization?.organizationName?.toLowerCase()?.includes(value)
    );
    if (value == "") setUsers(temp);
    if (searchArray.length > 0) {
      setUsers(searchArray);
    } else if (searchArray.length == 0) {
      setUsers(temp);
    }
  };

  return (
    <div>
      {contextHolder}
      <div className='sectionHeaderWrapper flex items-center content-between'>
        <div className='sectionHeaderTitle'> Manage Users </div>
        <Select
          options={options}
          defaultValue={options.filter((type) => type.value === userType)}
          style={{ width: "min(200px, 30vw)" }}
          onChange={(e) => {
            setUserType(e);
          }}
          styles={customStyles}
        />
      </div>
      {/* <button onClick={() => console.log(users)}>Show List</button> */}

      <div className='sectionContentWrapper'>
        {users && (
          <>
            <div className='sectionHeaderWrapper flex items-center content-between mt-0'>
              <form
                className='searchForm col-md-8'
                onSubmit={(e) => e.preventDefault()}
              >
                <button type='submit'>
                  <RiSearchLine />
                </button>
                <input
                  type='text'
                  placeholder='Search for names, emails, numbers'
                  onKeyUp={(e) => handleChange(e)}
                />
              </form>
              <button
                className='btn btn-primary w-auto'
                onClick={getAllUsersList}
              >
                {loading ? <Loader color='#fff' /> : <AiOutlineReload />}
              </button>
            </div>
            <AntdTable
              columns={columns}
              dataSource={users}
              scroll={{
                x: "auto",
                y: "auto",
              }}
              loading={users?.length == 0 && loading}
              pagination={{
                defaultCurrent: paginateStatus.current,
                pageSize: PageSize,
              }}
              onChange={(pagination, e) => {
                setPaginateStatus(pagination);
                setPageSize(pagination?.pageSize);
              }}
              sticky
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default AllUsers;
